import { render } from "./ScreenLoader.vue?vue&type=template&id=4d63961a&scoped=true"
import script from "./ScreenLoader.vue?vue&type=script&lang=js"
export * from "./ScreenLoader.vue?vue&type=script&lang=js"

import "./ScreenLoader.vue?vue&type=style&index=0&id=4d63961a&scoped=true&lang=css"

import exportComponent from "/home/pslcal/meruhensya.com/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d63961a"]])

export default __exports__